import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { ApiError } from '../../types/Error';
import { ScanRes } from '../../types/Scan';
import { getScan } from '../Scans';

export const getScanQueryKey = (scanId: string | number | undefined) => ['scan', String(scanId)];

interface UseGetScanProps {
    scanId: string | undefined;
    onError?: (err: ApiError) => void;
}

export const useGetScan = ({ scanId, onError }: UseGetScanProps): UseQueryResult<ScanRes | undefined, ApiError> => {
    const scanQueryResults = useQuery<ScanRes | undefined, ApiError>({
        queryKey: getScanQueryKey(scanId),
        queryFn: () => {
            if (!scanId) return Promise.resolve(undefined);
            return getScan(scanId);
        },
        retry: false,
        enabled: Boolean(scanId)
    });

    if (scanQueryResults.error && onError) {
        onError(scanQueryResults.error);
    }

    return scanQueryResults;
};
